import { Column, cssVar, Grid, Label, Row, useAlignments } from 'metrix-common3';
import styled from 'styled-components';

// One wide table at every breakpoint - the FilterableList track scrolls horizontally on screens too
// narrow to fit it, so mobile scrolls to all columns rather than collapsing to a subset. Column
// spans (matching the header in ../../fields.js) are set on xs only and inherited up to lg.

// Long values truncate on one line with an ellipsis (full value on hover) rather than overflow into
// the next column - except `wrap` cells (names, comma-joined quote lists) which read better wrapped.
const EllipsisLabel = styled(Label)`
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const WrapLabel = styled(Label)`
    display: block;
    overflow-wrap: break-word;
`;

const Cell = ({ text, textAlign, wrap }) => {
    if (wrap) return <WrapLabel text={text} textAlign={textAlign} />;
    return <EllipsisLabel text={text} title={text ? String(text) : undefined} textAlign={textAlign} />;
};

// The metrix Link is a flex box with no <p> margin, so its baseline sat above the data Cells (which
// are <p>-based Labels). Render the reference through the same EllipsisLabel instead - just coloured
// like a link and wrapped in an anchor - so it shares the exact margin/baseline of the other columns.
const RefLink = styled.a`
    display: block;
    text-decoration: none;
    cursor: pointer;
`;

const DemoPolicyWeb = ({ policy, context }) => {
    const alignments = useAlignments();

    const {
        insuredName,
        brokerCompanyName,
        assignedTo,
        submissionReferenceNumber,
        policyNumber,
        doingBusinessAs,
        productDescription,
        createdOnDate,
        transactionStatus,
        transactionType,
        policyTransactionGuid,
        quoteNumber,
        quoteColorTag,
    } = policy;

    const profileLink = `${context.configuration.policyWeb}/profile?entity=${policyTransactionGuid}`;

    return (
        <Grid>
            <Row>
                <Column xs={1}>
                    <RefLink href={profileLink}>
                        <EllipsisLabel
                            text={submissionReferenceNumber}
                            color={cssVar.colorSecondary}
                            clickable
                            title={submissionReferenceNumber}
                            textAlign={alignments.left}
                        />
                    </RefLink>
                </Column>
                <Column xs={1}>
                    <Cell text={policyNumber} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={quoteNumber} wrap textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={insuredName} wrap textAlign={alignments.left} />
                </Column>
                <Column xs={1.5}>
                    <Cell text={doingBusinessAs} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={productDescription} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={createdOnDate} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={transactionStatus} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={brokerCompanyName || ''} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={assignedTo || ''} textAlign={alignments.left} />
                </Column>
                <Column xs={0.5}>
                    <Cell text={quoteColorTag} textAlign={alignments.left} />
                </Column>
                <Column xs={1}>
                    <Cell text={transactionType} textAlign={alignments.left} />
                </Column>
            </Row>
        </Grid>
    );
};

export default DemoPolicyWeb;
